import { NotificationModel } from './../models/notification.model';
import { ApiResponseModel } from './../models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  baseUrl: string = environment.apiUrl;
  private notificationsSubject = new BehaviorSubject<NotificationModel[]>([]);
  public notifications$ = this.notificationsSubject.asObservable();

  constructor(private http: HttpClient) {}

  getNotificationList(): Observable<ApiResponseModel<NotificationModel[]>> {
    return this.http
      .get<ApiResponseModel<NotificationModel[]>>(
        `${this.baseUrl}/user/notification/list`
      )
      .pipe(
        tap((res: any) => {
          if (res?.data) {
            this.notificationsSubject.next(res.data);
          }
        })
      );
  }

  getNotificationAfterSignup(
    token: any
  ): Observable<ApiResponseModel<NotificationModel>> {
    return this.http.get<ApiResponseModel<NotificationModel>>(
      `${this.baseUrl}/user/signup/notification?` + token
    );
  }

  readNotification(
    id: string,
    token: string
  ): Observable<ApiResponseModel<NotificationModel>> {
    return this.http
      .get<ApiResponseModel<NotificationModel>>(
        `${this.baseUrl}/user/notification/seen/` + id + '?' + token
      )
      .pipe(tap(() => this.getNotificationList().subscribe()));
  }

  markAllAsRead(
    token: string
  ): Observable<ApiResponseModel<NotificationModel>> {
    return this.http
      .get<ApiResponseModel<NotificationModel>>(
        `${this.baseUrl}/user/seen/all/notification?` + token
      )
      .pipe(tap(() => this.getNotificationList().subscribe()));
  }
}
